import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'

import { Attachment } from './Attachment'

import { AttachmentsPlaceholder } from './AttachmentsPlaceholder'

import type { FC } from 'react'

type Props = {
  attachments?: AttachmentWithUploadStatus[]
  isDetailedView?: boolean
  onClickAttachment?: VoidFunction
  onClickAttachmentPlaceholder?: VoidFunction
  onRemoveAttachment?: (attachmentId: number) => void
}

export const Attachments: FC<Props> = ({ attachments, isDetailedView, onClickAttachment, onClickAttachmentPlaceholder, onRemoveAttachment }) => {
  if (!attachments?.length) return null

  const appliedAttachments = attachments.filter(({ errorType }) => !errorType)

  const hasPendingUploads = attachments.some(attachment => attachment.status === 'deleting' || attachment.status === 'uploading')

  const showAttachmentsPlaceHolder = onClickAttachmentPlaceholder && attachments.length > 2

  if (showAttachmentsPlaceHolder) {
    return (
      <AttachmentsPlaceholder
        attachmentCount={appliedAttachments.length}
        hasPendingUploads={hasPendingUploads}
        onClick={onClickAttachmentPlaceholder}
      />
    )
  }

  return attachments.map(attachment => (
    <Attachment
      attachment={attachment}
      isDetailedView={isDetailedView}
      key={attachment.id}
      onClickAttachment={onClickAttachment}
      onRemoveAttachment={onRemoveAttachment}
    />
  ))
}
